import type { TodoCalendar } from '@/api'

// The text of the "new todo" overlay: the first line is the title, the rest is the body. Nothing for a blank text.
export function parseNewTodo(text: string): { summary: string; description: string | null } | null {
  const lines = text.split(/\r?\n/)
  const first = lines.findIndex((line) => line.trim())
  if (first < 0) return null
  const description = lines
    .slice(first + 1)
    .join('\n')
    .trim()
  return { summary: lines[first].trim(), description: description || null }
}

// The list a new todo goes to: the one being looked at if it can be written to, else the default list, else the
// first writable one. None if there is no list to write to.
export function targetCalendar(
  calendars: TodoCalendar[],
  currentId: number | null,
): TodoCalendar | undefined {
  const writable = calendars.filter((calendar) => !calendar.readonly)
  return (
    writable.find((calendar) => calendar.id === currentId) ??
    writable.find((calendar) => calendar.is_default) ??
    writable[0]
  )
}
